import { render, staticRenderFns } from "./SucCalendarItemComponent.vue?vue&type=template&id=50d5f4bc&scoped=true&"
import script from "./SucCalendarItemComponent.vue?vue&type=script&lang=js&"
export * from "./SucCalendarItemComponent.vue?vue&type=script&lang=js&"
import style0 from "./SucCalendarItemComponent.vue?vue&type=style&index=0&id=50d5f4bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d5f4bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50d5f4bc')) {
      api.createRecord('50d5f4bc', component.options)
    } else {
      api.reload('50d5f4bc', component.options)
    }
    module.hot.accept("./SucCalendarItemComponent.vue?vue&type=template&id=50d5f4bc&scoped=true&", function () {
      api.rerender('50d5f4bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendar/SucCalendarItemComponent.vue"
export default component.exports